<hvac-dropdown-navigation class='hvac-user-detail-dropdown'
    [ngClass]="{ 'mobile': mobileMenuVisible$ | async }"
    [menuActive]="(headerDropdown$ | async) === 'userDetails'"
    [iconSrc]="icon"
    [title]="(userName$ | async)!"
    [menuOptions]="(detailOptions$ | async)!"
    (openMenuEmitter)="openUserDetailDropdown($event)">
</hvac-dropdown-navigation>
